import request from '@/utils/request2'

// 列表(主数据列表)
export function loadAppUserIntegralListDataApi(data) {
  return request({
    url: 'tms-web/appUserIntegral/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportAppUserIntegralListDataApi(data) {
  return request({
    url: 'tms-web/appUserIntegral/exportByPage',
    method: 'post',
    data
  })
}

// 导入
export function importAppUserIntegralApi(data) {
  return request({
    url: 'tms-web/appUserIntegral/saveByImport',
    method: 'post',
    data
  })
}

// 作废
export function deleteAppUserIntegralApi(data) {
  return request({
    url: 'tms-web/appUserIntegral/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewAppUserIntegralApi(data) {
  return request({
    url: 'tms-web/appUserIntegral/view',
    method: 'post',
    data
  })
}
